import action from 'app/lib/action';
import {TIME_SLOTS} from '../constants/actionTypes';

export default {
    request : (date, dom, days = 3) => action(TIME_SLOTS.REQUEST)({date, dom, days}),
    success : (timeSlots) => action(TIME_SLOTS.SUCCESS)({timeSlots}),
    error   : (error) => action(TIME_SLOTS.ERROR)({error})
};